import styled from 'styled-components';

export const StyledFilterPanelContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex-flow: wrap;
`;

export const StyledFilterPanelMobileContainer = styled.div`
  width: 100%;
  min-height: 48px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex-flow: wrap;
  margin: 1em 0 0;
`;
